import { SyntheticEvent } from 'react'
import { AutocompleteChangeDetails, AutocompleteChangeReason, AutocompleteFreeSoloValueMapping } from '@mui/material'
import { useField, useFormikContext } from 'formik'
import { Autocomplete, AutocompleteProps } from '@dhl/components'

type Props<T, FreeSolo extends boolean | undefined> = Omit<AutocompleteProps<T, FreeSolo>, 'value'> & {
  name: string
}

export function AutocompleteInput<T, FreeSolo extends boolean | undefined>({
  name,
  options,
  freeSolo,
  onChange: handleChange,
  ...props
}: Props<T, FreeSolo>): React.ReactElement {
  const [field, meta, helpers] = useField<null | T | AutocompleteFreeSoloValueMapping<FreeSolo>>(name)
  const { validateOnChange } = useFormikContext()

  const onChange = (
    event: SyntheticEvent,
    value: null | T | AutocompleteFreeSoloValueMapping<FreeSolo>,
    reason: AutocompleteChangeReason,
    details: AutocompleteChangeDetails<T>
  ) => {
    helpers.setTouched(true, false)
    helpers.setValue(value, validateOnChange)

    handleChange?.(event, value, reason, details)
  }

  return (
    <Autocomplete<T, FreeSolo>
      {...props}
      name={name}
      freeSolo={freeSolo}
      value={field.value}
      onChange={onChange}
      id={field.name}
      error={!!meta.error && meta.touched}
      helperText={meta.touched && meta.error}
      options={options}
    />
  )
}
